import { BUTTON_SIZES, BUTTON_VARIANTS } from 'ui/button';
import { colors } from 'ui/theme';
import {
  LimitExceededBack,
  LimitExceededBody,
  LimitExceededContainer,
  LimitExceededLayout,
  LimitExceededSpacedImage,
  LimitExceededTitle,
  MainLayoutWrapper,
} from './Styled';
import { TEST_IDS } from '../constants';

export const LimitExceededState = () => {
  return (
    <MainLayoutWrapper data-background-color={colors.white}>
      <LimitExceededLayout>
        <LimitExceededContainer data-test={TEST_IDS.GoalLimitPage}>
          <LimitExceededSpacedImage />
          <LimitExceededTitle>Limit reached</LimitExceededTitle>
          <LimitExceededBody>
            Each project can have up to six predictive goals. To create a new goal, first delete an
            existing one.
          </LimitExceededBody>
          <LimitExceededBack
            to="/predictive-audiences"
            size={BUTTON_SIZES.MEDIUM}
            variant={BUTTON_VARIANTS.SECONDARY}
          >
            Back to predictive goals
          </LimitExceededBack>
        </LimitExceededContainer>
      </LimitExceededLayout>
    </MainLayoutWrapper>
  );
};
